import { Component, Input } from '@angular/core';

@Component({
  selector: 'is-empty-state',
  templateUrl: './is-empty-state.component.html',
  styleUrls: ['./is-empty-state.component.scss']
})
export class IsEmptyStateComponent {

  @Input() marginBottom: string = '30px';
  @Input() height: string = '180px';
  @Input() width: string = '180px';
  @Input() fontSize: string = 'large';
  @Input() icon: string = 'no_data';
  @Input() title: string = 'oops_we_sorry';
  @Input() subtitle: string = 'we_didnt_find_any_result_for_your_search';
  @Input() lineHeight: string = '1.75rem';
  @Input() paddingTitle: string = 'opx';

  constructor() {}
}
